import { render } from "./ShiftHandover.vue?vue&type=template&id=62af0d78&scoped=true"
import script from "./ShiftHandover.vue?vue&type=script&lang=js"
export * from "./ShiftHandover.vue?vue&type=script&lang=js"

import "./ShiftHandover.vue?vue&type=style&index=0&id=62af0d78&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/HMS-MAIN/PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62af0d78"]])

export default __exports__